import * as uuid from 'uuid';

export const generateWebhookToken = () => {
  return uuid.v4().replace(/-/g, '');
}

export const generateUrl = (
  uid: string | undefined,
  type: string,
  token: string,
) => {
  const host = window.location.origin;

  return `${host}/api/v1/${type}/${uid || ''}/webhook?token=${token}`;
};
